<template>
  <v-stepper alt-labels v-model="step">
    <v-stepper-header>
      <v-stepper-step step="1"> </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="2"> </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3"> </v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  props: {
    step: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.v-sheet.v-stepper:not(.v-sheet--outlined) {
  box-shadow: none !important;
  background: transparent;

  .v-stepper__header {
    box-shadow: none;
    padding: 0 0 30px;

    .v-divider {
      margin: 14px -20px 0;
      align-self: flex-start;
      border: dashed;
      border-width: 2px 0 0 0;
      border-color: #66b512;
    }
  }

  .v-stepper__step {
    flex-basis: 70px;
    padding: 0;

    &:not(.v-stepper__step--active) {
      .v-stepper__step__step {
        border: 2px solid #66b512;
        background-color: transparent !important;
        color: #66b512;
      }
    }
  }

  .v-stepper__step__step {
    font-size: 18px;
    font-weight: bold;
    height: 30px;
    min-width: 30px;
    width: 30px;
    margin-bottom: 0;
  }
}
</style>
